import { render } from "./TheRoleWarning.vue?vue&type=template&id=48b8e3ae&lang=pug"
import script from "./TheRoleWarning.vue?vue&type=script&lang=js"
export * from "./TheRoleWarning.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__